import { ShopDataField } from '../../../../../../services';
import { MANDATORY_DATA_FIELDS_TO_DISPLAY } from '../../../../consts/mandatory-data-fields-to-display';

export const filterOutMandatoryDataFields = (dataFields?: ShopDataField[]) => {
  return dataFields?.filter(field => !MANDATORY_DATA_FIELDS_TO_DISPLAY.includes(field.name));
};
